import { autorun } from 'mobx';
import { Api } from '../../api';
import { SurveyStatus } from '../../survey';
import { ErrorLogger } from '../../lib/error-loger';
import type { App } from './App';

export class VisibilityChangeSubscription {
  constructor(private app: App) {
    this.unsubscribe = this.subscribe();

    autorun(() => {
      if (this.app.survey?.finished) {
        this.unsubscribe();
      }
    });
  }

  private subscribe() {
    document.addEventListener('visibilitychange', this.handleChange);

    return () => {
      document.removeEventListener('visibilitychange', this.handleChange);
    };
  }

  unsubscribe: () => void;

  private handleChange = () => {
    const handler = async () => {
      try {
        if (!this.app.survey) {
          return;
        }

        if (this.app.error || this.app.survey.finished) {
          return;
        }

        if (document.visibilityState === 'hidden') {
          await Api.sendSurveyStatus({
            id: this.app.survey.formVersionId,
            cm_id: this.app.survey.cmId,
            status: SurveyStatus.CLOSE_WIDGET,
          });
        } else {
          await Api.sendSurveyStatus({
            id: this.app.survey.formVersionId,
            cm_id: this.app.survey.cmId,
            status: SurveyStatus.ENTERED,
          });
        }
      } catch (err) {
        // Это ошибка вспомогательного запроса, поэтому она не должна попасть в app.error, только в логи.
        ErrorLogger.log(err);
      }
    };

    void handler();
  };
}
